import { ModelBase } from "../shared/model.base";
import { ColumnTitle } from "../../decorators/shared/column-title.decorator";
import { ColumnType } from "../../decorators/shared/column-type.decorator";
import { TableColumns } from "../../decorators/shared/table-columns.decorator";
import { DataType } from "../../enums/shared/enums";
import { Grupo } from "./grupo.type";

export class Miembro extends ModelBase {
    // @ColumnTitle('Nombre')
    // name: string;

    @ColumnTitle("Msisdn")
    msisdn: number;

    variable: Object | string = {};

    // Table Fields.
    //   @ColumnTitle('Fecha de Creacion')
    create_date: Date;

    groups: Array<Grupo>;

    constructor() {
        super();

        this.msisdn = null;
        // this.name = '';
        this.create_date = null;
    }
}
